"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE_MARGIN_BOTTOM = exports.MAX_WIDTH = exports.HEADER_HEIGHT = exports.DESKTOP_MARGIN_LEFT = exports.DEFAULT_TOP_POSITION = void 0;
var HEADER_HEIGHT = 50;
exports.HEADER_HEIGHT = HEADER_HEIGHT;
var DEFAULT_TOP_POSITION = 82;
exports.DEFAULT_TOP_POSITION = DEFAULT_TOP_POSITION;
var MAX_WIDTH = 328;
exports.MAX_WIDTH = MAX_WIDTH;
var MOBILE_MARGIN_BOTTOM = 16;
exports.MOBILE_MARGIN_BOTTOM = MOBILE_MARGIN_BOTTOM;
var DESKTOP_MARGIN_LEFT = 56;
exports.DESKTOP_MARGIN_LEFT = DESKTOP_MARGIN_LEFT;